import { render, staticRenderFns } from "./submitted.vue?vue&type=template&id=9e7d7bf8&scoped=true"
import script from "./submitted.vue?vue&type=script&lang=js"
export * from "./submitted.vue?vue&type=script&lang=js"
import style0 from "./submitted.vue?vue&type=style&index=0&id=9e7d7bf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7d7bf8",
  null
  
)

export default component.exports